<!-- 文件上传组件 -->
<template>
	<div class="multiple-upload">
		<el-input
			:placeholder="placeholder"
			:value="fileName"
			readonly="readonly"
			:disabled="disabled"
		>
			<template slot="append">
				<el-upload
					:on-success="onSuccess"
					:on-error="onError"
					class="upload-demo"
					:action="_action"
					:show-file-list="false"
					list-type="text"
					:data="params"
					:before-upload="beforeUpload"
					:loading="loading"
					:on-change="fileChange"
					:file-list="fileList"
					:accept="accept"
					:disabled="disabled"
					with-credentials
					:limit="limit"
					:multiple="multiple"
				>
					<el-button
						size="small"
						type="primary"
						:loading="loading"
						style="color: #1fa0e8"
					>{{ $t("components.upload.uploadField") }}</el-button>
				</el-upload>
			</template>
		</el-input>
	</div>
</template>

<script>
export default {
	name: 'MultipleUpload',
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: Array,
			default: function() {
				return []
			}
		},
		templateInfo: {
			type: Object,
			default: function() {
				return {}
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		accept: {
			type: String,
			default: '.pdf,.xlsx,.xls,.xlsm,.xltx,.xltm,.xlsb,.xlam'
		},
		region: {
			type: String,
			default: 'eu'
		},
		action: {
			type: String,
			default: '/file/eu/upload'
		},
		multiple: {
			type: Boolean,
			default: true
		},
		limit: {
			type: Number,
			default: 5
		}
	},
	data: function() {
		return {
			loading: false,
			fileList: [],
			params: {},
			fileName: '',
			domain: '',
			key: '',
			processLenth: 0
		}
	},

	computed: {
		_action() {
			return this.domain + this.action || '/file/eu/upload'
		}
	},
	watch: {
		value: {
			handler: function(val, oldVal) {
				if (val && val.length) {
					this.fileName =
						val.length === 1
							? val[0].fileName
							: `${val[0].fileName}  +${val.length}`
				}
			},
			immediate: true,
			deep: true
		}
	},
	mounted() {
		this.getUrl()
		this.getparams()
	},

	methods: {
		getUrl() {
			var domain = this.getEnv()
			this.domain = domain
		},
		getparams() {
			var params = {
				region: this.region || 'eu',
				app: 'merchant'
			}

			params['key'] = this.getCookie('fs_merchant')
			this.key = params['key']
			this.params = params
		},
		onSuccess(response, file, fileList) {
			this.loading = false
			if (response.resultCode !== 200) {
				this.$message.error(this.$t('components.upload.uploadFail'))
			} else {
				if (response) {
					const ret = [...this.value]
					const { fileName, filePath } = response.data
					ret.push({ fileName, filePath })

					this.$emit('input', ret)
					this.fileName =
						ret.length === 1
							? ret[0].fileName
							: `${ret[0].fileName}  +${ret.length}`
				}
			}
		},
		onError() {
			this.$emit('input', [])
			this.$message({
				type: 'error',
				message: this.$t('components.upload.uploadFail')
			})
		},

		beforeUpload(file) {
			this.loading = true
			const isLt5M = file.size / 1024 / 1024 < 5
			if (!isLt5M) {
				this.$message.error(
					this.$t('components.upload.fileTooLarge', {
						name: file.name,
						size: 5
					})
				)
				this.loading = false
			}
			return isLt5M
		},

		fileChange(file) {
			if (file.status === 'ready') {
				const interval = setInterval(() => {
					if (this.processLenth > 97) {
						clearInterval(interval)
						return
					}
					this.processLenth += Math.ceil(Math.random() * 3)
					this.$emit('percent', this.processLenth)
				}, 30)
			} else if (file.status === 'success') {
				this.processLenth = 100
				this.$emit('percent', this.processLenth)
				setTimeout(() => {
					this.processLenth = 0
					this.$emit('percent', this.processLenth)
				}, 500)
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.multiple-upload {
	::v-deep .el-input-group__append,
	.el-input-group__prepend {
		color: #3a8ee6 !important;
		background-color: transparent;
		border-top-right-radius: 20px !important;
		border-bottom-right-radius: 20px !important;
	}

	.el-upload {
		display: flex;
	}
	input {
		outline: none;
	}
	::v-deep .el-input__inner {
		border-right: none !important;
		border-top-left-radius: 20px !important;
		border-bottom-left-radius: 20px !important;
		white-space: nowrap; /* 使文本不可换行 */
		overflow: hidden; /* 隐藏溢出部分 */
		text-overflow: ellipsis;
	}

	.file-template {
		color: #3a8ee6;
	}
	.el-input.is-active .el-input__inner,
	.el-input__inner:focus {
		border-color: #dcdfe6;
	}
	.el-input__inner:hover {
		border-color: #dcdfe6;
	}
}
</style>
